/**
 * Shared currency formatting helper.
 *
 * CURRENCY_SYMBOLS is the single source of truth for the display symbols of the
 * six supported currencies.  formatCurrency uses these symbols directly so output
 * is consistent across the quiz slider (QuizStepConstraints), the review screen
 * (formatBudget), and the results page (formatMoney).
 *
 * For unrecognised currency codes the function falls back to Intl.NumberFormat
 * (full style:"currency") so it degrades gracefully rather than throwing.
 */

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  ZAR: "R",
  AUD: "A$",
  CAD: "C$",
};

export function formatCurrency(amount: number, currency: string): string {
  const symbol = CURRENCY_SYMBOLS[currency];
  if (symbol) {
    return `${symbol}${Math.round(amount).toLocaleString("en-US")}`;
  }
  // Fallback for unsupported codes.
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${Math.round(amount).toLocaleString("en-US")} ${currency}`;
  }
}
